import { announcementsRoutes } from '@/backend/routes';
import { AnnouncementsSlideout } from '@juvare/announcements/ui/features/announcements';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import React from 'react';
import { useNavigate } from 'react-router';

export const Announcements = () => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();

    return (
        <AnnouncementsSlideout
            onCreate={() => navigationContext.navigate(() => navigate(announcementsRoutes.form))}
            onEditAnnouncement={(entity) => {
                navigate(announcementsRoutes.form, { state: { entity } });
            }}
        />
    );
};
